/* eslint-disable no-loop-func */
import { MaxFlowProblem } from '../typings';
import { augmentCapacityAlongPath } from './helpers';

const { min } = Math;

export function stepFordFulkerson(
  problem: MaxFlowProblem,
  distanceLabels: number[],
  q: number[],
  curEdge: number,
  xf: number[],
  initDone: boolean,
  qHead: number,
  qTail: number
): [
  MaxFlowProblem,
  boolean,
  number[],
  boolean[][],
  boolean[][],
  number[],
  number[],
  number,
  number[],
  boolean,
  number,
  number
] {
  const visited: boolean[] = [];
  let u = problem.source;
  const path: number[] = [u];
  visited[u] = true;
  let goneDeeper;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    goneDeeper = false;
    if (u === problem.target) break;
    for (const v of problem.graph.cachedTargetKeys[u]) {
      if (problem.graph.edges[u][v].residualCapacity > 0) {
        if (visited[v]) continue;
        path.push(v);
        u = v;
        visited[u] = true;
        goneDeeper = true;
        break;
      }
    }
    if (!goneDeeper) {
      path.pop();
      if (path.length === 0) return [problem, true, [], [], [], [], [], 0, [], false, 0, 0];
      u = path[path.length - 1];
    }
  }

  let minResCap = Infinity;
  for (let i = 1; i < path.length; i += 1) {
    minResCap = min(minResCap, problem.graph.edges[path[i - 1]][path[i]].residualCapacity);
  }

  return [
    augmentCapacityAlongPath(problem, path, minResCap),
    false,
    path,
    [],
    [],
    [],
    [],
    0,
    [],
    false,
    0,
    0
  ];
}
